export const GET_GPP_BYGPID = "GET_GPP_BYGPID"
export const GET_GPP_BYGPID_SUCCESS = "GET_GPP_BYGPID_SUCCESS"
export const GET_GPP_BYGPID_FAIL = "GET_GPP_BYGPID_FAIL"

export const PROJECT_PROCESS = "PROJECT_PROCESS"
export const PROJECT_PROCESS_SUCCESS = "PROJECT_PROCESS_SUCCESS"
export const PROJECT_PROCESS_FAIL = "PROJECT_PROCESS_FAIL"

export const DEL_PROJECT_PROCESS = "DEL_PROJECT_PROCESS"
export const DEL_PROJECT_PROCESS_SUCCESS = "DEL_PROJECT_PROCESS_SUCCESS"
export const DEL_PROJECT_PROCESS_FAIL = "DEL_PROJECT_PROCESS_FAIL"

export const GET_LIST_PROJECT_PROCESS_ENG = "GET_LIST_PROJECT_PROCESS_ENG"
export const GET_LIST_PROJECT_PROCESS_REPORT = "GET_LIST_PROJECT_PROCESS_REPORT"
export const GET_LIST_PROJECT_PROCESS_ENG_SUCCESS = "GET_LIST_PROJECT_PROCESS_ENG_SUCCESS"
export const GET_LIST_PROJECT_PROCESS_ENG_FAIL = "GET_LIST_PROJECT_PROCESS_ENG_FAIL"

export const GET_PROJECT_PROCESS_ENG = "GET_PROJECT_PROCESS_ENG"
export const GET_PROJECT_PROCESS_REPORT = "GET_PROJECT_PROCESS_REPORT"
export const GET_PROJECT_PROCESS_ENG_SUCCESS = "GET_PROJECT_PROCESS_ENG_SUCCESS"
export const GET_PROJECT_PROCESS_ENG_FAIL = "GET_PROJECT_PROCESS_ENG_FAIL"


export const ACCEPTED_PROJECT_PROCESS = "ACCEPTED_PROJECT_PROCESS"
export const ACCEPTED_PROJECT_PROCESS_SUCCESS = "ACCEPTED_PROJECT_PROCESS_SUCCESS"
export const ACCEPTED_PROJECT_PROCESS_FAIL = "ACCEPTED_PROJECT_PROCESS_FAIL"

export const SELECT_GP = "SELECT_GP"
export const DESELECT_GP = "DESELECT_GP"

export const RESET_GAS_PROCESS_FLAG = "RESET_GAS_PROCESS_FLAG"